import React, { ReactNode } from 'react';
import styles from './TripleLines.module.scss';

interface TripleLinesProps {
  children: ReactNode;
  variant: 'topLeft' | 'topRight' | 'bottomRight';
  isLargeSize?: boolean;
  className?: string;
  isContentFullWidth?: boolean;
}

const TripleLines: React.FC<TripleLinesProps> = ({
  children,
  variant,
  isLargeSize = false,
  className,
  isContentFullWidth = false,
}) => {
  const getVariantStyleClass = () => {
    switch (variant) {
      case 'topLeft':
        return isLargeSize ? styles.topLeftImage : styles.topLeft;
      case 'topRight':
        return styles.topRight;
      case 'bottomRight':
        return isLargeSize ? styles.bottomRightImage : styles.bottomRight;
    }
  };

  return (
    <div
      className={[styles.tripleLines, isContentFullWidth ? styles.fullWidth : undefined]
        .filter(Boolean)
        .join(' ')}
    >
      <span
        className={[
          getVariantStyleClass(),
          isContentFullWidth ? styles.fullWidth : undefined,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {children}
      </span>
    </div>
  );
};

export default TripleLines;
